// removed by extract-text-webpack-plugin
module.exports = {"forms":"c-MembershipForms__forms"};